var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 9.625C3.5 6.24226 6.24226 3.5 9.625 3.5C13.0078 3.5 15.75 6.24226 15.75 9.625C15.75 13.0078 13.0078 15.75 9.625 15.75C6.24226 15.75 3.5 13.0078 3.5 9.625ZM9.625 1.75C5.27576 1.75 1.75 5.27576 1.75 9.625C1.75 13.9743 5.27576 17.5 9.625 17.5C11.4844 17.5 13.1933 16.8556 14.5405 15.7779L17.7563 18.9937C18.098 19.3354 18.652 19.3354 18.9937 18.9937C19.3354 18.652 19.3354 18.098 18.9937 17.7563L15.7779 14.5405C16.8556 13.1933 17.5 11.4844 17.5 9.625C17.5 5.27576 13.9743 1.75 9.625 1.75Z",
    fill: "#717784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 12.25C8.75 12.7333 9.14174 13.125 9.625 13.125C10.1083 13.125 10.5 12.7333 10.5 12.25V10.5H12.25C12.7333 10.5 13.125 10.1083 13.125 9.625C13.125 9.14174 12.7333 8.75 12.25 8.75H10.5V7C10.5 6.51675 10.1083 6.125 9.625 6.125C9.14174 6.125 8.75 6.51675 8.75 7V8.75H7C6.51675 8.75 6.125 9.14174 6.125 9.625C6.125 10.1083 6.51675 10.5 7 10.5H8.75V12.25Z",
    fill: "#717784"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.49eefb9f8db4ab3bbf11c84edb606e76.svg";
export { ForwardRef as ReactComponent };